module.exports = __webpack_public_path__ + "images/Info-circle.4119ae18fb7412349f0320f0c1149d41.svg";